/* START_MODULE_CONTRACT
 * PURPOSE: Точка входа React: монтирование App в DOM (StrictMode).
 * SCOPE: createRoot и render.
 * DEPENDS: M-FE-APP
 * LINKS: M-FE-APP
 * ROLE: SCRIPT
 * MAP_MODE: NONE
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * index - bootstrap ReactDOM.createRoot(...).render(App).
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-03 - Исправлен синтаксис block-комментария GRACE: `/ *` → `/*` (Babel parse error).
 * END_CHANGE_SUMMARY
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
